export const apiConstants = {
  scope: 'mock-data/scope.json',
  users: 'mock-data/auth/users.json',
  signin: 'mock-data/signin.json',
  signout: 'mock-data/signout.json',
  checkAuth: 'mock-data/checkAuth.json',
  register: 'mock-data/register.json',
  profile: 'mock-data/profile.json'
};
